module.exports = __webpack_public_path__ + "static/media/handshakeB.4deac48d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Icons/handshakeB.svg
// module id = 551
// module chunks = 0